import { spawn } from 'redux-saga/effects';
import sheetManagerSagas from '../../sheet/redux/sagas';

export default function* rootSaga() {
  yield spawn(sheetManagerSagas);
}
